import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import { sanitizeMeasurementId, withSendTo } from './googleAnalyticsScope.js'

// One Analytics instance per measurement id for the tab's lifetime (gtag keeps every id it
// has seen configured anyway); only the ACTIVE id moves as the visitor navigates.
const instances = new Map()
let analytics = null
// The measurement id of the page the visitor is on. Every page_view / event is scoped to it
// with `send_to`, because gtag keeps earlier ids configured across client-side navigation.
let activeMeasurementId = null

const init = (rawMeasurementId) => {
  const measurementId = sanitizeMeasurementId(rawMeasurementId)
  // Cleared first: a page without its own (usable) GA4, or one whose setup fails, must not
  // report into a previous page's property.
  activeMeasurementId = null
  analytics = null
  if (!measurementId) return
  try {
    if (!instances.has(measurementId)) {
      instances.set(measurementId, Analytics({
        app: 'nimi',
        plugins: [
          googleAnalytics({
            measurementIds: [measurementId]
          })
        ]
      }))
    }
    analytics = instances.get(measurementId)
    activeMeasurementId = measurementId
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}

const pageView = () => {
  if (!analytics || !activeMeasurementId) return
  try {
    const url = window.location.href
    analytics.page(withSendTo({ url }, activeMeasurementId))
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}

const initCheckout = (params) => {
  if (!analytics || !activeMeasurementId) return
  try {
    analytics.track('begin_checkout', withSendTo(params, activeMeasurementId))
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}

const purchase = (params) => {
  if (!analytics || !activeMeasurementId) return
  try {
    analytics.track('purchase', withSendTo(params, activeMeasurementId))
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}


export default {
  init,
  pageView,
  initCheckout,
  purchase
}
